
import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/services/LoggingService';
import { useAuthStore } from '@/stores/authStore';

export async function getUser() {
  try {
    // Prefer AuthStore (synchronous, no network) to reduce false negatives/spam on flaky networks
    const storeUser = useAuthStore.getState().user;
    if (storeUser) {
      return storeUser;
    }

    // Fallback to Supabase if store not yet hydrated
    const { data: { user }, error } = await supabase.auth.getUser();
    if (error) {
      logger.error('UserService.getUser', 'Error getting user', { error });
      return null;
    }
    return user;
  } catch (error) {
    logger.error('UserService.getUser', 'Unexpected error in getUser', { error });
    return null;
  }
}
